import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Ref } from 'vue-property-decorator';
import EdInputModel from '@/models/ed-input.model';
import EdFormModel from '@/models/ed-form.model';
import { required, maxLength, minLength } from 'vuelidate/lib/validators';

@Component({
  name: 'ed-edit-dialog'
})
export default class EdEditDialogComponent extends Vue {
  public form: any = {};
  private initialValue: string = '';
  public isFocused: boolean = false;
  private validationsObj: any = {};
  private readonly maxLength: number = 60;
  private readonly keyboardEvent: string = 'keydown';
  private readonly keyCodes: any = {
    Escape: 'Escape',
  }

  /* Props */
  @Prop() readonly params: any;

  /* Refs */
  @Ref('main') readonly main: HTMLElement;
  @Ref('textField') readonly textField: HTMLElement;

  get showRangeLength () {
    return this.params.showRangeLength || false;
  }

  get inputTextValue(): string {
    return this.form.inputText.value?.trim();
  }

  get isValidinputText(): boolean {
    const length: number = this.inputTextValue?.length;
    return length >= Number(this.minLengthValue || 0) && length <= Number(this.maxLengthValue);
  }

  get maxLengthValue() {
    return this.params.maxLength || this.maxLength;
  }

  get minLengthValue() {
    return this.params.minLength || false;
  }

  get isRequired () {
    return this.params.required || false;
  }

  get counterLength () {
    return this.showRangeLength ? this.maxLengthValue : null;
  }

  formValidations(): any {
    if(this.isRequired) this.validationsObj = {required};
    if(this.minLengthValue) this.validationsObj.minLength = minLength(this.params.minLength);
    if(this.maxLengthValue) this.validationsObj.maxLength = maxLength(this.maxLengthValue);
  }

  initForm(initialValue): void {
    this.form = EdFormModel([
      EdInputModel('inputText', initialValue, this.validationsObj, true),
    ]);
  }

  /* Methods */
  save(): void {
    if (this.isValidinputText) {
      if ((this.inputTextValue !== this.initialValue) && this.params.onChangeCallback) {
        this.params.onChangeCallback(this.inputTextValue);
      }
      this.closeModal();
      return;
    }
  }

  closeModal(): void {
    this.$EdModal.closeModal();
  }

  containerClickListener(event: PointerEvent) {
    if (!this.main?.contains((event?.target as HTMLElement)) && !this.isFocused) {
      this.closeModal();
    }
  }

  onFocus() {
    this.isFocused = true;
  }

  onBlur() {
    this.isFocused = false;
  }

  private _keyboardEventListener(event: KeyboardEvent): void {
    if (this.keyCodes.Escape === event.code) {
      this.closeModal();
    }
  }

  /* Hooks  */
  created() {
    this.initialValue = this.params?.inputText;
    this.formValidations();
    this.$nextTick(() => {
      this.initForm(this.initialValue);
    });
  }

  mounted() {
    window.addEventListener(this.keyboardEvent, this._keyboardEventListener);
  }

  beforeDestroy() {
    window.removeEventListener(this.keyboardEvent, this._keyboardEventListener);
  }
}
